import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, Row, Col, Typography } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import apiClient from '../services/api';

const { Title } = Typography;

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    try {
      setLoading(true);
      setError(''); 
      await login(values);
      // Lấy thông tin user sau khi đăng nhập thành công
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Đăng nhập thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" align="top" style={{ minHeight: '100vh', paddingTop: 40 }}>
      <Col xs={22} sm={16} md={10} lg={8} xl={6} style={{ textAlign: 'center' }}>
        <img
          src={process.env.PUBLIC_URL + '/logo_asm.png'}
          alt="Logo ASM"
          style={{ height: 300, width: 300, objectFit: 'contain', borderRadius: 24, marginBottom: 8 }}
        />
        <Card variant="outlined" style={{ boxShadow: '0 2px 8px #f0f1f2' }}>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              onClose={() => setError('')}
              style={{ marginBottom: 16 }}
            />
          )}
          <Form layout="vertical" onFinish={onFinish} autoComplete="off">
            <Form.Item
              label="Tên đăng nhập"
              name="username"
              rules={[{ required: true, message: 'Tên đăng nhập là bắt buộc' }]}
            >
              <Input placeholder="Nhập tên đăng nhập" size="large" />
            </Form.Item>
            <Form.Item
              label="Mật khẩu"
              name="password"
              rules={[{ required: true, message: 'Mật khẩu là bắt buộc' }]}
            >
              <Input.Password placeholder="Nhập mật khẩu" size="large" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
              >
                Đăng nhập
              </Button>
            </Form.Item>
            <div style={{ textAlign: 'center', display: 'none' }}>
              <span>Chưa có tài khoản? </span>
              <Link to="/register">Đăng ký ngay</Link>
            </div>
          </Form>
        </Card>
        {/* Sau form đăng nhập */}
        {/* Ẩn tính năng tìm kiếm tài sản theo nhân viên - vẫn giữ lại code để dễ bật lại sau */}
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Link to="/employee-search" style={{ fontWeight: 600, color: '#1677ff', fontSize: 16 }}>
            Tìm kiếm tài sản theo nhân viên
          </Link>
        </div>
      </Col>
    </Row>
  );
};

export default LoginPage; 